<template>
  <SelectButton
    v-model="model"
    class="pricing-filter"
    :options="options"
    option-label="name"
    option-value="value"
    :allow-empty="false"
    :disabled="disabled"
    v-bind="$attrs"
    size="small"
  />
</template>

<script setup lang="ts">
import { PriceInterval } from '~/utils/enums/Price';

defineOptions({
  inheritAttrs: false,
});

const model = defineModel(PriceInterval.MONTH);

withDefaults(
  defineProps<{
    disabled?: boolean;
  }>(),
  {
    disabled: false,
  },
);

const options = [
  {
    name: 'Pay Monthly',
    value: 'month',
  },
  {
    name: 'Pay Yearly',
    value: 'year',
  },
];
</script>

<style lang="scss">
@use '~/assets/scss/partials/_colors';
$border-radius: 999px;

:root {
  .pricing-filter {
    background: #dde1e5;
    border: 0;
    padding: 2px;
    border-radius: $border-radius;
    overflow: hidden;
    display: flex;
    width: fit-content;
    gap: 8px;

    .p-togglebutton {
      border-radius: $border-radius !important;
      border: 0px;
      background: transparent;
      color: $text-color-secondary;
      font-weight: 600;
      padding-left: 16px;
      padding-right: 16px;

      &.p-togglebutton-checked {
        background: white;
        color: $text-color-primary;
      }
    }
  }
}
</style>
